import { ArrowForward } from '@mui/icons-material'
import { Alert, AlertTitle, Divider, Drawer, IconButton, Typography } from '@mui/material'
import './TrBulkEdit.css'
import {
  COLUMN_CONFIG_TR,
  updatesForColumn,
  ITES_AR_COLUMNS,
  preSubmitItesArLine,
  preSubmitSewpTrLine,
  TR_COLUMNS,
} from './TechnicalRequest'
import { EditableCell } from '../draft/EditableCell'
import { useMemo } from 'react'

export default function TrBulkEdit<T extends preSubmitSewpTrLine & preSubmitItesArLine>({
  open,
  selectedLineItems,
  contractVehicle,
  contractNumber,
  setLineItems,
  onClose,
}: {
  open: boolean
  selectedLineItems: T[]
  contractVehicle: string
  contractNumber: string | null
  setLineItems: (lineItems: React.SetStateAction<T[]>) => void
  onClose: () => void
}) {
  const columns = useMemo(() => (contractVehicle === 'ITES-4H' ? ITES_AR_COLUMNS : TR_COLUMNS), [contractVehicle])

  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <div className="tr-bulk-edit">
        <div className="tr-bulk-edit-header">
          <Typography variant="h6">Bulk Edit</Typography>
          <IconButton onClick={onClose}>
            <ArrowForward />
          </IconButton>
        </div>

        <Divider />

        <div className="tr-bulk-edit-content">
          <Alert severity="info">
            <AlertTitle>
              {selectedLineItems.length} item{selectedLineItems.length === 1 ? '' : 's'} selected for editing
            </AlertTitle>
            All {selectedLineItems.length} item{selectedLineItems.length === 1 ? '' : 's'} will be updated to reflect
            any changes made.
          </Alert>
          <div>
            {columns.map(column => {
              const config = COLUMN_CONFIG_TR[column.name]
              if (config.nonEdit || column.name === 'Description' || !('property' in config)) return null
              return (
                <div key={column.name}>
                  <Typography>{column.header}</Typography>
                  <EditableCell
                    alwaysEdit
                    canEdit
                    value={
                      selectedLineItems.length > 0 &&
                      selectedLineItems.every(item => item[config.property] === selectedLineItems[0][config.property])
                        ? selectedLineItems[0][config.property]
                        : null
                    }
                    onChange={value => {
                      setLineItems(prev =>
                        prev.map(item =>
                          selectedLineItems.some(selectedItem => selectedItem.LineItemId === item.LineItemId)
                            ? {
                                ...item,
                                [config.property]: value,
                                ...updatesForColumn({ ...item, [config.property]: value }, column.name),
                              }
                            : item,
                        ),
                      )
                    }}
                    inputType={config.format}
                    source={config.masterList}
                    contractNumber={contractNumber}
                    options={config.options}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Drawer>
  )
}
